import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GuidStrValue, MedicationListFilterDto, PatientTrackResultFilter, TrackPatientResultsDto } from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ListFilterRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  getMedicationFilter(filterId: GuidStrValue): Observable<MedicationListFilterDto> {
    const endpointUrl = `list-filter/medication-hx/${filterId}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  postMedicationFilter(filter: MedicationListFilterDto): Observable<MedicationListFilterDto> {
    const endpointUrl = `list-filter/medication-hx`;
    return this.httpClientService.sendPostRequest(endpointUrl, filter);
  }

  postTrackPatientResultsFilter(filter: PatientTrackResultFilter): Observable<PatientTrackResultFilter> {
    const endpointUrl = `list-filter/track-patient-results`;
    return this.httpClientService.sendPostRequest(endpointUrl, filter);
  }

  postTrackPatientResultsFilterSaveAs(filter: PatientTrackResultFilter): Observable<PatientTrackResultFilter> {
    const endpointUrl = `list-filter/track-patient-results`;
    return this.httpClientService.sendPostRequest(endpointUrl, filter);
  }

  postApplyTrackPatientResults(
    patientUid: GuidStrValue,
    filter: PatientTrackResultFilter
  ): Observable<TrackPatientResultsDto> {
    const endpointUrl = `patients/${patientUid}/track-patient-results-search`;
    return this.httpClientService.sendPostRequest(endpointUrl, filter);
  }

  getTrackPatientResultsFilter(filterId: GuidStrValue): Observable<PatientTrackResultFilter> {
    const endpointUrl = `list-filter/track-patient-results/${filterId}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

 getTrackPatientResultsByFilter(
    patientUid: GuidStrValue,
    filterId: GuidStrValue | null,
    useDefaultFilter: boolean
  ): Observable<TrackPatientResultsDto> {
    const endpointUrl = `patients/${patientUid}/track-patient-results`;
    let params = new HttpParams().set('useDefaultFilter', useDefaultFilter.toString());

    if (filterId) {
      params = params.set('filterId', filterId);
    }

    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }

}
